const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT'
const SET_SHOW = 'SET_SHOW'

const state = () => ({
  message: {
    text: '',
    center: true,
  },

  title: {
    text: '',
    show: true,
  },

  confirmButton: {
    text: 'Aceptar',
    show: true,
    action: () => {}
  },

  cancelButton: {
    text: 'Cancelar',
    show: false,
    action: () => {}
  },

  question: {
    text: '',
    show: false,
  },

  icon: 'mdi-alert-outline',
  show: false,
  persistent: true,
  isHtml: false,
})

const getters = {
  show: state => state.show,
  text: state => state.message.text,
  textCenter: state => state.message.center,
  textTitle: state => state.title.text,
  showTitle: state => state.title.show,
  textConfirmButton:  state => state.confirmButton.text,
  showConfirmButton: state => state.confirmButton.show,
  actionConfirmButton: state => state.confirmButton.action,
  textCancelButton: state => state.cancelButton.text,
  showCancelButton: state => state.cancelButton.show,
  actionCancelButton: state => state.cancelButton.action,
  textQuestion: state => state.question.text,
  showQuestion: state => state.question.show,
  icon: state => state.icon,
  persistent: state => state.persistent,
  isHtml: state => state.isHtml
}

const mutations = {
  [SET_SHOW]: (state, show) => {
    state.show = show
  },

  [SET_MODAL_CONTENT]: (state, modalContent) => {
    const {
      text,
      textTitle,
      showTitle,
      textConfirmButton,
      showConfirmButton,
      actionConfirmButton,
      textCancelButton,
      showCancelButton,
      actionCancelButton,
      textQuestion,
      showQuestion,
      icon,
      persistent,
      isHtml,
    } = {...modalContent}

    const setElementIfNotNull = (stateValue, newValue) => {
      if (typeof(newValue) !== 'undefined' && newValue !== null) {
        return newValue
      } 
      return stateValue
    }

    state.message.text = setElementIfNotNull(state.message.text, text)
    state.title.text = setElementIfNotNull(state.title.text, textTitle)
    state.title.show = setElementIfNotNull(state.title.show, showTitle)
    state.confirmButton.text = setElementIfNotNull(state.confirmButton.text, textConfirmButton)
    state.confirmButton.show = setElementIfNotNull(state.confirmButton.show, showConfirmButton)
    state.confirmButton.action = setElementIfNotNull(state.confirmButton.action, actionConfirmButton)
    state.cancelButton.text = setElementIfNotNull(state.cancelButton.text, textCancelButton)
    state.cancelButton.show = setElementIfNotNull(state.cancelButton.show, showCancelButton)
    state.cancelButton.action = setElementIfNotNull(state.cancelButton.action, actionCancelButton)
    state.question.text = setElementIfNotNull(state.question.text, textQuestion)
    state.question.show = setElementIfNotNull(state.question.show, showQuestion)
    state.icon = setElementIfNotNull(state.icon, icon)
    state.persistent = setElementIfNotNull(state.persistent, persistent)
    state.isHtml = setElementIfNotNull(state.isHtml, isHtml)
  }
}

const setModal = ({ commit }, modalContent) => {
  commit(SET_MODAL_CONTENT, modalContent)
  commit(SET_SHOW, true)
}

const closeModal = ({ commit }) => {
  const modalContent = {
    text: '',
    textTitle: '',
    showTitle: true,
    textConfirmButton: 'Aceptar',
    showConfirmButton: true,
    actionConfirmButton: () => {},
    textCancelButton: 'Cancelar',
    showCancelButton: false,
    actionCancelButton: () => {},
    textQuestion: '',
    showQuestion: false,
    icon: 'mdi-alert-outline',
    persistent: true,
    isHtml: false,
  }

  commit(SET_SHOW, false)
  commit(SET_MODAL_CONTENT, modalContent)
}

const actions = {
  setModal,
  closeModal,
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}